import { render, staticRenderFns } from "./PersonalRobberyEventTypeQuestion.vue?vue&type=template&id=57a061c9&scoped=true"
import script from "./PersonalRobberyEventTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./PersonalRobberyEventTypeQuestion.vue?vue&type=script&lang=ts"
import style0 from "./PersonalRobberyEventTypeQuestion.vue?vue&type=style&index=0&id=57a061c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a061c9",
  null
  
)

export default component.exports